
import Vue from 'vue';

Vue.component ('global-header', require ('./components/global/Header.vue').default);

Vue.component ('global-footer', require ('./components/global/Footer.vue').default);

Vue.component ('white-space', require ('./components/_widget/WhiteSpace.vue').default);

Vue.component ('res-item-select', require ('./components/resource/ResItemSelect.vue').default);

Vue.component('sidebar',require('./components/global/sidebar').default)

// Vue.component('QuillEditor',require('./components/_widget/QuillEditor').default)

// Vue.component('FroalaEditor',require('./components/_widget/FroalaEditor').default)

Vue.component('FroalaEditor',  () => import(/* webpackChunkName: "FroalaEditor" */'./components/_widget/FroalaEditor') )

Vue.component('Empty',  require('./components/_widget/Empty').default )

//省份城市二级
Vue.component('ProvinceCity',  require('./components/_widget/ProvinceCity').default )

//FrontFlag
Vue.component('FrontFlag',  require('./components/_widget/FrontFlag').default )

//ResultCount
Vue.component('ResultCount',  require('./components/_widget/ResultCount').default )

//购物车
Vue.component('CartBalls',  require('./components/_widget/CartBalls').default )


// WEBPACK FOOTER //
// ./src/Component.js